import {RentVehicleResponseBody, ReturnVehicleResponseBody} from '@dms/api/rental';

import {Nullish} from 'shared/web';

import {parseBatteryCharge} from './parseBatteryCharge';

type RentalOrderBatteryChargeSource = {
  rentVehicle: Pick<RentVehicleResponseBody, 'batteryCharge'> | null;
  returnVehicle: Pick<ReturnVehicleResponseBody, 'batteryCharge'> | null;
};

/**
 * @about Resolves the battery charge shown for a rental order: the charge recorded on return,
 * falling back to the charge recorded on rent, or null when neither carries a usable charge.
 */
export function getRentalOrderBatteryCharge(
  rentalOrder: RentalOrderBatteryChargeSource | Nullish
): number | null {
  return parseBatteryCharge(
    rentalOrder?.returnVehicle?.batteryCharge ?? rentalOrder?.rentVehicle?.batteryCharge
  );
}
